const firebaseConfig = {
    apiKey: "AIzaSyDxkNhgK8Utz5IZoNzv4WVXIylxQ1Z2RsM",
    authDomain: "assignment-11-72aaf.firebaseapp.com",
    projectId: "assignment-11-72aaf",
    storageBucket: "assignment-11-72aaf.appspot.com",
    messagingSenderId: "927171735407",
    appId: "1:927171735407:web:e65b24a18221f74241029a"
  };
export default firebaseConfig;

  